import { PAGE_TYPE } from "app/umbraco/pages/page.types";
import OverlayRootState from "layout/models/redux-state.interface";

export default (currentPage: PAGE_TYPE, styles: any, overlay?: OverlayRootState): string | undefined => {
    if (overlay?.currentOverlay === "PRODUCTS_MENU") {
        return styles.is_open;
    }

    if (currentPage && (currentPage._contentType === "category" || currentPage._contentType === "product" || currentPage._contentType === "mediaCloudPage")) {
        return styles.is_active;
    }

    return undefined;
};
